import { InfoCircleOutlined } from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './erp-product-tag.module.scss';

// Icon marker for products created in the ERP (no CMS / website product);
// the explanation shows on hover. Renders nothing for regular products.
// See server erpProductController.js.
export const ErpProductTag = ({ product, style }) => {
    if (!product?.is_erp_product) {
        return null
    }
    return (
        <Tooltip title="ERP product — created in the ERP, not on the website">
            <span className={styles.icon} style={style} aria-label="ERP product" role="img">
                <InfoCircleOutlined />
            </span>
        </Tooltip>
    )
}

ErpProductTag.propTypes = {
    product: PropTypes.shape({
        is_erp_product: PropTypes.bool,
    }),
    style: PropTypes.object,
}

// Text chip variant ("Manual product") for titles/headers of ERP-created products.
export const ManualProductTag = ({ product, style }) => {
    if (!product?.is_erp_product) {
        return null
    }
    return (
        <Tooltip title="Created in ERP — not on the website">
            <Tag
                style={{ color: '#9254de', borderColor: '#d3adf7', background: '#fff', fontSize: 11, lineHeight: '16px', padding: '0 5px', fontWeight: 'normal', marginInlineStart: 8, verticalAlign: 'middle', cursor: 'default', ...style }}
            >
                Manual product
            </Tag>
        </Tooltip>
    )
}

ManualProductTag.propTypes = {
    product: PropTypes.shape({
        is_erp_product: PropTypes.bool,
    }),
    style: PropTypes.object,
}
